
export class DialogOptions {
    data?: any;
    modal?: boolean;
}
